import React from "react";
import styles from "./CodeSnippet.module.scss";
import classNames from "classnames";
import CopyButton from "./CopyButton"
import SyntaxHighlighter from "./SyntaxHighlighter";

const CodeSnippet = React.memo(({ text, className, style, highLightLanguage, contentClassName, contentStyle }) => {
    return <div className={classNames(styles.base, className)} style={style}>
        <div className={classNames(styles.content, contentClassName)} style={contentStyle}>
            {!highLightLanguage && <code>{text}</code>}
            {highLightLanguage && <SyntaxHighlighter language={highLightLanguage}>{text}</SyntaxHighlighter>}
        </div>
        <CopyButton className={styles.copy} text={text} color="secondary"/>
    </div>
});

export default CodeSnippet;